module.exports = __webpack_public_path__ + "img/candlingInfertile.af7ac4f2.svg";